import script from "./DoctorRegist.vue?vue&type=script&setup=true&lang=ts"
export * from "./DoctorRegist.vue?vue&type=script&setup=true&lang=ts"

import "./DoctorRegist.vue?vue&type=style&index=0&id=d42814c4&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d42814c4"]])

export default __exports__